// extracted by mini-css-extract-plugin
export var phone = "_3q-0";